ace.define("ace/snippets/pgsql",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="pgsql"})


//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/ace-builds/src-min-noconflict/snippets/pgsql.js
// module id = 1750
// module chunks = 3